"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerModuleResolver = exports.throw = exports.export = exports.import = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var config = _interopRequireWildcard(require("./config"));

var _scriptLoaderPromise = require("./loader/scriptLoaderPromise");

var _cssLoader = require("./loader/cssLoader");

var _promiseOnce = _interopRequireDefault(require("./util/promiseOnce"));

var _module = _interopRequireWildcard(require("./module"));

var moduleResolverMap = {};
var loadModule = (0, _promiseOnce.default)( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(moduleKey, moduleInfo) {
    var isModule, type, _options, _type, _type2, _moduleInfo$js, js, _moduleInfo$css, css, _moduleInfo$dep, dep, orderExec, options, moduleLoad, depLoad;

    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (moduleInfo) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return");

          case 2:
            isModule = moduleInfo.type !== 'immediate';

            if (!(moduleInfo.type && isModule)) {
              _context4.next = 13;
              break;
            }

            type = moduleInfo.type;

            if (typeof type !== 'string') {
              _type = type;
              _type2 = (0, _slicedToArray2.default)(_type, 2);
              type = _type2[0];
              _options = _type2[1];
            }

            if (!moduleResolverMap[type]) {
              _context4.next = 12;
              break;
            }

            _context4.next = 9;
            return moduleResolverMap[type](moduleKey, moduleInfo, _options);

          case 9:
            return _context4.abrupt("return", _context4.sent);

          case 12:
            throw new Error("There is no resolver for type: ".concat(type));

          case 13:
            _context4.prev = 13;
            if (isModule) (0, _module.register)(moduleKey);
            _context4.next = 20;
            break;

          case 17:
            _context4.prev = 17;
            _context4.t0 = _context4["catch"](13);
            return _context4.abrupt("return");

          case 20:
            _moduleInfo$js = moduleInfo.js, js = _moduleInfo$js === void 0 ? [] : _moduleInfo$js, _moduleInfo$css = moduleInfo.css, css = _moduleInfo$css === void 0 ? [] : _moduleInfo$css, _moduleInfo$dep = moduleInfo.dep, dep = _moduleInfo$dep === void 0 ? [] : _moduleInfo$dep, orderExec = moduleInfo.orderExec, options = moduleInfo.options;

            moduleLoad = /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
                var jsLoad, cssLoad;
                return _regenerator.default.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        jsLoad = orderExec ? (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
                          var i;
                          return _regenerator.default.wrap(function _callee$(_context) {
                            while (1) {
                              switch (_context.prev = _context.next) {
                                case 0:
                                  i = 0;

                                case 1:
                                  if (!(i < js.length)) {
                                    _context.next = 7;
                                    break;
                                  }

                                  _context.next = 4;
                                  return (0, _scriptLoaderPromise.load)(js[i], options);

                                case 4:
                                  i++;
                                  _context.next = 1;
                                  break;

                                case 7:
                                case "end":
                                  return _context.stop();
                              }
                            }
                          }, _callee);
                        }))() : js.map(function (f) {
                          return (0, _scriptLoaderPromise.load)(f, options);
                        });
                        cssLoad = css.map(function (f) {
                          return (0, _cssLoader.load)(f);
                        });
                        _context2.next = 4;
                        return Promise.all([].concat((0, _toConsumableArray2.default)(jsLoad), (0, _toConsumableArray2.default)(cssLoad)));

                      case 4:
                        if (isModule) (0, _module.update)(moduleKey, 2);

                      case 5:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function moduleLoad() {
                return _ref2.apply(this, arguments);
              };
            }();

            depLoad = /*#__PURE__*/function () {
              var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
                var depLoad;
                return _regenerator.default.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        depLoad = dep.map(_import);
                        _context3.next = 3;
                        return Promise.all(depLoad);

                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function depLoad() {
                return _ref4.apply(this, arguments);
              };
            }();

            _context4.next = 25;
            return Promise.all([moduleLoad(), depLoad()]);

          case 25:
            if (isModule) (0, _module.update)(moduleKey, 5);
            return _context4.abrupt("return", moduleInfo);

          case 27:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[13, 17]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());

var isArrayModules = function isArrayModules(modules) {
  return Object.prototype.toString.call(modules) === '[object Array]';
};

var _import = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
    var modules,
        isSingle,
        timeout,
        moduleInfos,
        _args5 = arguments;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            modules = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : [];
            isSingle = false;
            timeout = (0, config.getTimeout)();

            if (!isArrayModules(modules)) {
              modules = [modules];
              isSingle = true;
            }

            moduleInfos = modules.map(config.moduleInfoResolver);
            _context5.next = 7;
            return Promise.all(moduleInfos.map(function (moduleInfo) {
              return loadModule(moduleInfo.key, moduleInfo);
            }));

          case 7:
            _context5.next = 9;
            return Promise.all(moduleInfos.map(function (moduleInfo, i) {
              return moduleInfo.type !== 'immediate' && (0, _module.wait)(moduleInfo.key, 6, timeout);
            }));

          case 9:
            return _context5.abrupt("return", isSingle ? (0, _module.getExports)(moduleInfos[0].key) : moduleInfos.map(function (moduleInfo) {
              return (0, _module.getExports)(moduleInfo.key);
            }));

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function _import() {
    return _ref5.apply(this, arguments);
  };
}();

exports.import = _import;

var _export = function _export(moduleName, module) {
  if ((0, _module.defined)(moduleName)) {
    console.error("Warning: Module ".concat(moduleName, " already existed, you can't export duplicated"));
  } else {
    (0, _module.update)(moduleName, 6, {
      exports: module
    });
  }
};

exports.export = _export;

var _throw = function _throw(moduleName, error) {
  if ((0, _module.defined)(moduleName)) {
    console.error("Warning: Module ".concat(moduleName, " already existed, you can't update it to error"));
  } else {
    (0, _module.update)(moduleName, 7, {
      error: error
    });
  }
};

exports.throw = _throw;

var registerModuleResolver = function registerModuleResolver(resolverGenerator) {
  resolverGenerator({
    module: _module,
    config: config,
    import: _import,
    export: _export,
    throw: _throw,
    register: function register(type, resolver) {
      return moduleResolverMap[type] = resolver;
    }
  });
};

exports.registerModuleResolver = registerModuleResolver;
//# sourceMappingURL=mod.js.map